import styled from 'styled-components';
import { Card } from '../Card';
import { DataTable } from '../Datatable';

export const CommercialDocBox = styled(Card)`
  background-color: var(--color-card-background, #ffffff);
  border: 1px solid var(--color-card-border, #e5e9f0);
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  padding: 20px 22px;

  .bp4-dark & {
    box-shadow: none;
    border-color: var(--color-dark-gray4, #383e47);
  }
`;

export const CommercialDocHeader = styled.div`
  margin-bottom: 20px;

  /*
   * Compact header "façon Balance": the horizontal field list (type, n°, date,
   * référence…) no longer stacks as tall full-width rows with a 180px label
   * gutter — it wraps into inline label-over-value chips across one or two
   * lines. Cascades to every detail drawer that uses CommercialDocHeader.
   */
  .details-menu--horizantal {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px 32px;

    .detail-item {
      flex-direction: column;
      margin-top: 0;
      min-width: 0;

      &__label {
        /* neutralize the inline minLabelSize (e.g. 180px) passed by drawers */
        min-width: 0 !important;
        padding-inline-end: 0;
        margin-bottom: 2px;
      }
      &__content {
        width: auto;
      }
    }
  }
`;

export const CommercialDocTopHeader = styled.div`
  margin-bottom: 30px;
`;

export const CommercialDocEntriesTable = styled(DataTable)`
  /* Balance-style entries grid: hairline muted borders instead of the legacy
     hard black rules, uppercase 10px heads, tabular-nums figures. Applies to
     every detail-drawer entries table at once. */
  font-size: 12px;

  && .thead .th {
    background: var(--color-datatable-head-background, #f8fafc);
    color: var(--color-datatable-head-text, #64748b);
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    border-top: 0;
    border-bottom: 1px solid var(--color-datatable-head-border, #e2e8f0);
    padding: 8px 12px;
  }

  && .tbody .tr .td {
    padding: 8px 12px;
    border-bottom: 1px solid var(--color-datatable-cell-border, #f1f5f9);
    font-variant-numeric: tabular-nums;
  }

  && .tbody .tr:last-child .td {
    border-bottom: 1px solid var(--color-datatable-head-border, #e2e8f0);
  }

  .bp4-dark & {
    && .thead .th {
      background: var(--color-dark-gray2, #2f343c);
      border-bottom-color: var(--color-dark-gray4, #383e47);
    }
    && .tbody .tr .td,
    && .tbody .tr:last-child .td {
      border-bottom-color: var(--color-dark-gray4, #383e47);
    }
  }
`;

export const CommercialDocFooter = styled.div`
  margin-top: 28px;
`;
